import type { IIqeRunResultsRequest } from '../../interfaces/api/requests/runResults.request';

export function toIqeRunResultsUrl({
  apmNumber,
  projectId,
  runId,
  type,
}: IIqeRunResultsRequest): string {
  return `service/iqe/${apmNumber}/project/${projectId}/runs/${runId}/results?type=${type}`;
}
